module.exports = __webpack_public_path__ + "img/101ne.a06afe6b.svg";